import React from 'react';
import { AssistantSettingsSection } from '../../settings/sections/AssistantSettingsSection';
import { MemoryFactsPanel } from './MemoryFactsPanel';

type CustomizeSection = 'overview' | 'skills' | 'historic';

const SECTIONS: Array<{ id: CustomizeSection; label: string }> = [
  { id: 'overview', label: 'Fakten' },
  { id: 'skills', label: 'Skills' },
  { id: 'historic', label: 'Wissen aus Rechnungen' },
];

export function ChatCustomizeView() {
  const [section, setSection] = React.useState<CustomizeSection>('overview');

  return (
    <div className="mx-auto w-full max-w-4xl px-6 py-8">
      <h2 className="text-lg font-bold text-app-text">Anpassungen</h2>
      <p className="mt-1 text-sm text-app-text-muted">Wissen, Skills und Rechnungen für den Assistenten.</p>
      <div className="mt-4 mb-5 flex gap-6 border-b border-app-border">
        {SECTIONS.map((item) => {
          const active = section === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setSection(item.id)}
              className={`-mb-px border-b-2 pb-2.5 text-sm ${
                active
                  ? 'border-pipedrive-blue font-medium text-app-text'
                  : 'border-transparent text-app-text-muted hover:text-app-text'
              }`}
            >
              {item.label}
            </button>
          );
        })}
      </div>
      {section === 'skills' ? (
        <AssistantSettingsSection part="skills" embedded />
      ) : (
        <MemoryFactsPanel section={section} />
      )}
    </div>
  );
}
